import { required } from 'vuelidate/lib/validators';
import { ModelSelect } from 'vue-search-select';
import appStrings from '@/app/utility/string.utility';
import commonHelper from '@/app/utility/common.helper.utility';
import {
  updateCityData,
  addCityData,
  getCountryState
} from '@/app/services/api';

export default {
  name: 'City',
  props: {
    showModalState: Boolean,
    formState: String
  },
  components: {
    ModelSelect
  },
  watch: {
    'cityForm.country.value': function() {
      const countryId = this.cityForm.country.value;
      this.getCountryState(true, countryId);
    },
    defaultCountryId: function() {
      const countryId = this.defaultCountryId;
      this.getCountryState(false, countryId);
    },
    defaultStateId: function() {
      this.currentPage = 1;
      this.getFilteredCity();
    },
    currentPage: function() {
      this.getFilteredCity();
    },
    search: function() {
      this.currentPage = 1;
      if (this.search && this.search.length >= 3) {
        this.getFilteredCity();
      }
      if (this.search.length === 0) {
        this.getFilteredCity();
      }
    },
    perPage: function() {
      this.currentPage = 1;
      this.getFilteredCity();
    }
  },
  data() {
    return {
      payload: null,
      unsubscribe: null,
      search: '',
      data: [],
      stateId: '',
      defaultCountryId: '',
      defaultStateId: '',
      cityForm: {
        country: {
          value: '',
          text: ''
        },
        state: {
          value: '',
          text: ''
        },
        city: ''
      },
      stateCountryData: [],
      cityStateData: [],
      citiesStateData: [],
      pageOptions: commonHelper.getPageOption(),
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      stickyHeader: true,
      totalRows: null,
      filterOn: [],
      showModal: false,
      editMode: false,
      editState: false,
      responseMsg: '',
      isSuccess: false,
      isFailed: false,
      update: false,
      showAlert: false,
      formCountryData: [],
      formStateData: [],
      fields: [
        {
          key: 'country',
          sortable: true
        },
        {
          key: 'state',
          sortable: true
        },
        {
          key: 'city',
          sortable: false
        }
      ]
    };
  },
  validations: {
    cityForm: {
      country: {
        value: {
          required
        },
        text: {
          required
        }
      },
      state: {
        value: {
          required
        },
        text: {
          required
        }
      },
      city: {
        required
      }
    }
  },
  mounted() {
    this.getCountryList();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'edit' || actionName === 'update') {
          this.editMode = true;
          this.update = true;
        }

        if (actionName === 'add') {
          this.resetForm();
          this.showAlert = false;
          this.showModal = true;
          this.editMode = true;
          this.update = false;
        }

        if (actionName === 'download' && !this.showModal) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'country/getFilteredCityList',
            'city',
            () => (this.loader = false)
          );
        }

        if (actionName === 'save') {
          this.updateCityData();
        }
        if (actionName === 'upload' && this.showModal) {
          this.eventBus.$emit('commonUpload', { id: this.cityId });
        }
      }
    });
  },
  methods: {
    async getCountryList() {
      try {
        const response = await this.$store.dispatch('country/getCountryList');
        const results = response.data.data;
        const stateCountry = results.map(type => {
          return {
            value: type.country_id,
            text: type.country
          };
        });
        this.stateCountryData = stateCountry;
        this.formCountryData = this.stateCountryData;
        if (
          this.stateCountryData !== null &&
          this.stateCountryData.length > 0
        ) {
          this.defaultCountryId = this.stateCountryData[0].value;
        }
      } catch (err) {
        this.err = err;
      }
    },

    async getCountryState(isFormModified, countryId) {
      try {
        const response = await getCountryState(countryId);
        const results = response.data.data;
        const cityCountry = results.map(type => {
          return {
            value: type.state_id,
            text: type.state
          };
        });

        if (isFormModified) {
          this.formStateData = cityCountry;
        } else {
          this.cityStateData = cityCountry;
        }
        if (this.cityStateData !== null && this.cityStateData.length > 0) {
          this.defaultStateId = this.cityStateData[0].value;
        }
      } catch (err) {
        this.err = err;
      }
    },

    async getFilteredCity() {
      this.payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        state_id: this.defaultStateId,
        city_name: this.search
      };
      if (this.defaultStateId) {
        try {
          const queryParams = {
            stateId: this.defaultStateId,
            page: this.currentPage - 1,
            limit: this.perPage,
            search: this.search
          };
          const response = await this.$store.dispatch(
            'city/getCityList',
            queryParams
          );
          const results = response.data.data.page;
          this.data = response.data.data.page;
          this.totalRows = response.data.data.total_elements;
          const city = results.map(type => {
            return {
              value: type.city_id,
              text: type.city
            };
          });
          this.citiesStateData = city;
        } catch (err) {
          this.err = err;
        }
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.pageOptions[5].value = filteredItems.length;
    },
    resetModal() {
      this.$emit('clicked', 'view');
      this.editMode = false;
      this.update = false;
      this.cityForm.city = '';
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    rowSelected: function(item) {
      this.showModal = true;
      this.update = true;
      this.showAlert = false;
      this.cityId = item.city_id;
      this.cityForm.country.text = item.country;
      this.cityForm.country.value = item.country_id;
      this.cityForm.state.text = item.state;
      this.cityForm.state.value = item.state_id;
      this.cityForm.city = item.city;
    },
    created: function() {
      this.getCountryList(), this.getCountryState();
    },
    updateCityData: function() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit('clicked', 'edit');
        this.update = false;
        return;
      } else {
        const requestBody = {
          state_id: this.cityForm.state.value,
          city_name: this.cityForm.city
        };
        if (this.update) {
          updateCityData(requestBody, this.cityId)
            .then(response => {
              if (response && response.status === 200) {
                this.getCountryList();
                this.showAlert = true;
                this.isSuccess = true;
                this.editMode = false;
                this.update = false;
                this.responseMsg = appStrings.citySuccessMsg;
              } else {
                this.showAlert = true;
                this.isSuccess = false;
                this.responseMsg = appStrings.autoFailedMsg;
              }
            })
            .catch(err => {
              this.err = err;
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg = appStrings.autoFailedMsg;
            });
        } else {
          addCityData(requestBody)
            .then(response => {
              this.getCountryList();
              if (response && response.status === 201) {
                this.showAlert = true;
                this.isSuccess = true;
                this.editMode = false;
                this.update = false;
                this.responseMsg = appStrings.cityAddedMsg;
              } else {
                this.showAlert = true;
                this.isSuccess = false;
                this.responseMsg = appStrings.autoFailedMsg;
              }
            })
            .catch(err => {
              this.err = err;
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg = appStrings.autoFailedMsg;
            });
        }
      }
    },
    resetForm() {
      this.cityForm = {
        country: {
          value: '',
          text: ''
        },
        state: {
          value: '',
          text: ''
        },
        city: ''
      };
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
